import { atom } from "recoil"
import { InspirationModel } from "src/components/views/avatars/components/Inspirations"

export const queuedInspirationAtom = atom<InspirationModel | null>({
  key: "queuedInspirationAtom",
  default: null
})
